import React from 'react';
const DeleteSVG = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="24"
      viewBox="0 0 23 24"
      fill="none"
      className={className}
    >
      <path
        d="M3.79412 6.17647V20.4118C3.79412 21.8412 4.95291 23 6.38235 23H16.7353C18.1648 23 19.3235 21.8412 19.3235 20.4118V6.17647M3.79412 6.17647H2.5M3.79412 6.17647H6.38235M19.3235 6.17647H20.6176M19.3235 6.17647H16.7353M6.38235 6.17647V3.58824C6.38235 2.15879 7.54114 1 8.97059 1H14.1471C15.5765 1 16.7353 2.15879 16.7353 3.58824V6.17647M6.38235 6.17647H16.7353M8.97059 11.3529V17.8235M14.1471 11.3529V17.8235"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DeleteSVG;
